// @flow

import './commons/gilroy.css';
import React, { type Node, Suspense } from 'react';
import { type LookAndFeelRootProps } from '@tectonics/look-and-feel';
import { GlobalStyle } from './commons/global-style';
import { ShopifyThemeProvider, type ShopifyTheme } from './commons/theme';
import LoadingPayment from './pages/loading-payment/loading-payment';

const OpenedPaymentPage = React.lazy(() => import('./pages/opened-payment'));
const ConfirmedPaymentPage = React.lazy(() => import('./pages/confirmed-payment'));
const PendingPaymentPage = React.lazy(() => import('./pages/pending-payment'));
const CanceledPaymentPage = React.lazy(() => import('./pages/canceled-payment'));

export default function Shopify(props: LookAndFeelRootProps): Node {
  return (
    <WithAssets>
      <Page {...props} />
    </WithAssets>
  );
}

function Page(props: LookAndFeelRootProps): Node {
  if (props.stage === 'loading') {
    return <LoadingPayment />;
  }
  return <StatusPage {...(props: any)} />;
}

function StatusPage(props: LookAndFeelRootProps): Node {
  return (
    <Suspense fallback={<LoadingPayment />}>
      <StatusPageImpl {...props} />
    </Suspense>
  );
}

function StatusPageImpl(props: LookAndFeelRootProps): Node {
  switch (props.stage) {
    case 'payment-opened': return <OpenedPaymentPage {...props} />;
    case 'payment-confirmed': return <ConfirmedPaymentPage {...props} />;
    case 'payment-pending': return <PendingPaymentPage {...props} />;
    case 'payment-canceled': return <CanceledPaymentPage {...props} />;
    default: throw new Error(`Shopify - StatusPageImpl - status "${props.stage}" does not contains a page implementation`);
  }
}

type WithAssetsProps = {|
  children: Node,
|};

function WithAssets({ children }: WithAssetsProps): Node {
  const theme: ShopifyTheme = {
    fontFamily: {
      sansSerif: '"Open Sans", "OpenSans", "Helvetica Neue", Helvetica, Arial, sans-serif',
      display: '"Gilroy", "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica,sans-serif',
    },
    colors: {
      gray: [ '#fafafa', '#eeeeee', '#738093', '#4e5e75', null],
      secondaryGray: ['#dddddd', '#666666', '#5c5c5c', null, null, null],
      primary: [ null, null, null, null, null],
    },
  };

  return (
    <ShopifyThemeProvider theme={theme}>
      <>
        <GlobalStyle />
        {children}
      </>
    </ShopifyThemeProvider>
  );
}
